<div class="driver-modal">
  <div class="sec_head pad_btm">
    <h2>{{ 'ProvideExpectedDeliveryDate' | translate }}</h2>
  </div>

  <div class="modal-body">
    <form
      class="attribute-modal"
      [formGroup]="expectedDeliveyDateForm"
      (ngSubmit)="onSubmit()">
      <div class="form_group">
        <mat-form-field appearance="fill" class="">
          <input
            matInput
            [matDatepicker]="picker1"
            matInput
            formControlName="expectedDate"
            onkeydown="return false"
            [min]="currentDate()"
            [placeholder]="'StartDate' | translate"
            class="form_control" />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>
      <!-- <div class="error-box">
        <mat-error *ngIf="submitted && showError">{{
          'ProvideReason' | translate
        }}</mat-error>
      </div> -->
      <div class="submit_btn flex_btn">
        <button class="btnn btn_primary" type="submit">
          {{ 'Save' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
